import React from 'react';
import { EmptyStateIcon } from '../Icons/svgIcons';

const EmptyState = ({
  icon, 
  title = "No Data Found",
  message = "There's nothing to show here right now.",
  action,
  actionLabel
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <div className="relative mb-8 animate-fade-in">
        <div className="absolute inset-0 icon-bg-theme opacity-20 rounded-3xl blur-2xl transform scale-110"></div>
        <div className="relative w-24 h-24 rounded-3xl flex items-center justify-center icon-bg-theme shadow-sm border border-gray-100 animate-gentle-float">
          <div className="icon-theme">
            {icon || <EmptyStateIcon className="w-14 h-14 icon-theme" />}
          </div>
        </div>
      </div>

      <div className="space-y-3 max-w-sm animate-fade-in-up">
        <h3 className="text-xl font-bold text-[var(--text-main)] tracking-tight">
          {title}
        </h3>
        <p className="text-sm text-[var(--text-sec)] leading-relaxed">
          {message}
        </p>
      </div>

      {action && actionLabel && (
        <button
          onClick={action}
          className="mt-8 px-6 py-2.5 bg-[var(--btn-primary-bg)] text-white text-sm font-semibold rounded-lg shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5 active:scale-95 animate-fade-in-up"
          style={{ animationDelay: '100ms' }}
        >
          {actionLabel}
        </button>
      )}

      <style>{`
        @keyframes gentle-float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-8px);
          }
        }

        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fade-in-up {
          from {
            opacity: 0;
            transform: translateY(12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .animate-gentle-float {
          animation: gentle-float 3s ease-in-out infinite;
        }

        .animate-fade-in {
          animation: fade-in 0.6s ease-out;
        }

        .animate-fade-in-up {
          animation: fade-in-up 0.6s ease-out backwards;
        }
      `}</style>
    </div>
  );
};

export default EmptyState;